import React from 'react';
import { QueueRegistry } from './queue-registry';

export const QueueRegistryContext = React.createContext<QueueRegistry | undefined>(undefined);
